export const G6LineType = {
    Product: 'Product',
    Config: 'Config',
    Aggregation: 'Aggregation',
    ReturnableItem: 'ReturnableItem',
    Delivery: 'Delivery',
    Discount: 'Discount',
};
export const G6ReceiptLineType = {
    Section: 'Section',
    ReturnableItem: 'ReturnableItem',
    Product: 'Product',
    Delivery: 'Delivery',
};
